export const ENTITY_STATE = {
    loaded: 0,
    inserted: 1,
    edited: 2,
    removed: 3
}

export const SUBJECT_TYPE = {
    unknown: 0,
    company: 1,
    person: 2,
    document: 3
};

export const PORTFOLIO_TYPES = {
    companyCz: 1,
    cadastreSk: 2,
    personCz: 3,
    companySk: 4,
    personSk: 5
}